module.exports = __webpack_public_path__ + "img/icon-client-card@3x.099af7cf.png";